import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import VendorGrades from './VendorGrades';
import historyProps from '../../Lib/Utils/PropTypes/history-props';
import locationProps from '../../Lib/Utils/PropTypes/location-props';
import Locations from '../Locations/Locations';
import Page from '../Page/index.ts';
import Header from '../Header/index.ts';

export default function DeliveryManagement(props) {
  const {
    fetchVendors,
    loading,
    vendors,
    location,
    locations,
    getLocations,
    createLocation,
    updateLocation,
    history,
    vendorCount,
    currentUser,
  } = props;
  const [locationsFetched, setLocationsFetched] = useState(false);
  useEffect(() => {
    if (!locationsFetched) {
      getLocations();
      setLocationsFetched(true);
    }
  }, [locationsFetched, getLocations]);

  return (
    <Page.Container withoutTwp>
      <Header.Major icon="settings/settings-02" title="Delivery Management" />
      <Page.Content>
        <Locations
          createLocation={createLocation}
          updateLocation={updateLocation}
          locations={locations}
          currentUser={currentUser}
        />
        <div className="w-full h-10" />
        <VendorGrades
          fetchVendors={fetchVendors}
          loading={loading}
          location={location}
          history={history}
          vendors={vendors}
          vendorCount={vendorCount}
        />
      </Page.Content>
    </Page.Container>
  );
}

DeliveryManagement.propTypes = {
  createLocation: PropTypes.func.isRequired,
  fetchVendors: PropTypes.func.isRequired,
  getLocations: PropTypes.func.isRequired,
  history: historyProps.isRequired,
  loading: PropTypes.bool.isRequired,
  location: locationProps.isRequired,
  locations: PropTypes.shape({}).isRequired,
  updateLocation: PropTypes.func.isRequired,
  vendorCount: PropTypes.number.isRequired,
  vendors: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
